import { render, staticRenderFns } from "./CustomIde.vue?vue&type=template&id=6323628c&scoped=true&"
import script from "./CustomIde.vue?vue&type=script&lang=js&"
export * from "./CustomIde.vue?vue&type=script&lang=js&"
import style0 from "./CustomIde.vue?vue&type=style&index=0&id=6323628c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6323628c",
  null
  
)

export default component.exports